import React from 'react'

import { Modal, Button, Form } from '_zari/core'
import { ZariContext } from '_zari/context'

import { IdGen } from 'utils'

import SeleccionUbicacionModal from '../seleccionUbicacion'

const filaVacia = () => ({
  _idFila: IdGen.newId(),
  numeroSerieProveedor: '',
  _idAlmacen: '',
  _idUbicacion: '',
  _idEstanteria: '',
  codigoUbicacion: '',
  etiquetaUbicacion: '',
  nombreAlmacen: '',
  codigoEstanteria: ''
})

const RegistroActivosFijosModal = ({ show, handleClose, filaProducto, onGuardar }) => {
  const __zariContext = React.useContext(ZariContext)

  const cantidadEsperada = parseInt(filaProducto?.cantidad || '0', 10)

  const [unidades, setUnidades] = React.useState(() => {
    const existentes = filaProducto?.unidades || []
    const arr = []
    for (let i = 0; i < cantidadEsperada; i++) {
      arr.push(existentes[i] ? { ...existentes[i], _idFila: IdGen.newId() } : filaVacia())
    }
    return arr
  })

  const [filaUbicacionIdx, setFilaUbicacionIdx] = React.useState(null)

  const totalAsignadas = unidades.filter(u => u._idUbicacion).length

  const actualizarCampo = (idFila, campo, valor) => {
    setUnidades(prev => prev.map(u => (u._idFila === idFila ? { ...u, [campo]: valor } : u)))
  }

  const abrirUbicacion = idx => setFilaUbicacionIdx(idx)

  const onUbicacionElegida = ubicacion => {
    if (filaUbicacionIdx == null) return
    setUnidades(prev =>
      prev.map((u, i) =>
        i === filaUbicacionIdx
          ? {
              ...u,
              _idAlmacen: ubicacion._idAlmacen,
              _idEstanteria: ubicacion._idEstanteria,
              _idUbicacion: ubicacion._idUbicacion,
              codigoUbicacion: ubicacion.codigoUbicacion,
              etiquetaUbicacion: ubicacion.etiquetaUbicacion,
              nombreAlmacen: ubicacion.nombreAlmacen,
              codigoEstanteria: ubicacion.codigoEstanteria
            }
          : u
      )
    )
    setFilaUbicacionIdx(null)
  }

  const guardar = () => {
    for (let i = 0; i < unidades.length; i++) {
      const u = unidades[i]
      if (!u._idUbicacion) {
        __zariContext.snack('error', `Unidad #${i + 1}: asigna ubicación.`)
        return
      }
    }
    onGuardar(unidades.map(({ _idFila, ...rest }) => rest))
  }

  const filaUbicacionActual = filaUbicacionIdx != null ? unidades[filaUbicacionIdx] : null
  const valorUnitario = parseFloat(filaProducto?.precio || '0')

  return (
    <>
      <Modal show={show} size='lg' onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>
            <i className='fa fa-th-large mr-2' style={{ color: '#1E40AF' }} />
            REGISTRAR UNIDADES · ACTIVO FIJO
            <small className='ml-2 text-muted'>
              · {filaProducto?.nombreProducto || filaProducto?.codigoProducto} · {cantidadEsperada} unidades
            </small>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className='mb-3 p-2'
            style={{ background: '#DBEAFE', border: '1px solid #BFDBFE', borderRadius: 4, fontSize: '0.78rem' }}
          >
            Cada unidad recibe un <b>cód. patrimonial</b> autogenerado al guardar (es el ID interno para control,
            depreciación y traslados). El <b>N° de serie del proveedor</b> es opcional, captura manual desde la etiqueta
            física del equipo. Cada unidad lleva su propia ubicación física.
            {filaProducto?.codigoBarra && (
              <div className='mt-1'>
                Cód. Barras del Proveedor (del maestro): <b style={{ fontFamily: 'monospace' }}>{filaProducto.codigoBarra}</b>
              </div>
            )}
          </div>

          <table className='table table-sm table-bordered' style={{ fontSize: '0.78rem' }}>
            <thead style={{ background: '#DBEAFE', color: '#1E40AF' }}>
              <tr>
                <th style={{ width: 40 }}>#</th>
                <th style={{ width: 180 }}>Cód. Patrimonial</th>
                <th style={{ width: 180 }}>N° Serie Proveedor</th>
                <th>Ubicación en Almacén</th>
                <th style={{ width: 100, textAlign: 'right' }}>Valor</th>
              </tr>
            </thead>
            <tbody>
              {unidades.map((u, idx) => (
                <tr key={u._idFila}>
                  <td className='text-center'>{idx + 1}</td>
                  <td>
                    <input
                      type='text'
                      className='form-control form-control-sm'
                      value='(se genera al guardar)'
                      readOnly
                      style={{ fontFamily: 'monospace', background: '#F7F9FC', color: '#6B7280', fontSize: '0.7rem' }}
                    />
                  </td>
                  <td>
                    <Form.InputText
                      id={`numeroSerie-${u._idFila}`}
                      name={`numeroSerie-${u._idFila}`}
                      value={u.numeroSerieProveedor}
                      onChange={e => actualizarCampo(u._idFila, 'numeroSerieProveedor', e.target.value)}
                      placeholder='Opcional'
                    />
                  </td>
                  <td>
                    {u._idUbicacion ? (
                      <div
                        style={{ cursor: 'pointer', fontSize: '0.75rem' }}
                        onClick={() => abrirUbicacion(idx)}
                        title='Click para cambiar'
                      >
                        <strong style={{ color: '#1F3A8A' }}>{u.etiquetaUbicacion}</strong>
                        <span className='text-muted ml-1'>{u.codigoEstanteria}</span>
                        <div className='text-muted'>{u.nombreAlmacen}</div>
                      </div>
                    ) : (
                      <Button size='sm' outline color='primary' onClick={() => abrirUbicacion(idx)}>
                        <i className='fa fa-map-marker-alt mr-1' />
                        Asignar
                      </Button>
                    )}
                  </td>
                  <td className='text-right'>
                    {valorUnitario.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <div style={{ marginRight: 'auto', fontSize: '0.85rem' }}>
            <span
              style={{
                color: totalAsignadas === cantidadEsperada ? '#059669' : '#D97706',
                fontWeight: 600
              }}
            >
              <span
                className='d-inline-block mr-1'
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  background: totalAsignadas === cantidadEsperada ? '#059669' : '#D97706'
                }}
              />
              {totalAsignadas} / {cantidadEsperada} unidades con ubicación
            </span>
          </div>
          <Button color='secondary' onClick={handleClose}>
            Cancelar
          </Button>
          <Button color='primary' onClick={guardar} disabled={totalAsignadas !== cantidadEsperada}>
            Guardar unidades
          </Button>
        </Modal.Footer>
      </Modal>

      {filaUbicacionActual && (
        <SeleccionUbicacionModal
          show={true}
          handleClose={() => setFilaUbicacionIdx(null)}
          onSeleccionado={onUbicacionElegida}
          valorActual={
            filaUbicacionActual._idUbicacion
              ? {
                  _idAlmacen: filaUbicacionActual._idAlmacen,
                  _idEstanteria: filaUbicacionActual._idEstanteria,
                  _idUbicacion: filaUbicacionActual._idUbicacion
                }
              : null
          }
          nombreProducto={`${filaProducto?.nombreProducto || ''} · Unidad ${(filaUbicacionIdx ?? 0) + 1}`}
          cantidad={1}
        />
      )}
    </>
  )
}

export default RegistroActivosFijosModal
